/**
 * ts-whoweare.js - /pages/who-we-are
 *
 * 1. Reveals each chapter once as it scrolls in (the fade-slide).
 * 2. Makes the crew photo's spotlight work on touch. Hover drives the scrim,
 *    the masked relight and the bubble on desktop via CSS alone; a touch
 *    screen has no hover, so tapping a person's band toggles data-open and a
 *    tap elsewhere clears it.
 *
 * No library. Opacity, transform and width only.
 *
 * Reveals are driven by a direct scroll-position check rather than an
 * IntersectionObserver. The chapters start at opacity 0, so anything that
 * stops the observer firing leaves the whole page blank below the hero -
 * too expensive a failure for a cosmetic effect. A plain getBoundingClientRect
 * check on scroll cannot get wedged, drains its own list as sections reveal,
 * and removes its listeners when the last one is done.
 */
(function () {
  if (!/\/pages\/who-we-are/.test(location.pathname)) return;

  function reveals() {
    var pending = Array.prototype.slice.call(document.querySelectorAll('.ws-sec'));
    if (!pending.length) return;

    // first chapter is above the fold - show it without waiting for a scroll
    pending[0].classList.add('is-in');

    function check() {
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      for (var i = pending.length - 1; i >= 0; i--) {
        var b = pending[i].getBoundingClientRect();
        // reveal once the section has entered the lower part of the viewport
        if (b.top < vh * 0.85 && b.bottom > 0) {
          pending[i].classList.add('is-in');
          pending.splice(i, 1);
        }
      }
      if (!pending.length) stop();
    }

    function stop() {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);

    check();
    // safety net for load orders where layout settles after first paint
    setTimeout(check, 300);
    setTimeout(check, 1200);
    window.addEventListener('load', check);
  }

  function crew() {
    var bands = Array.prototype.slice.call(document.querySelectorAll('.ws-hs'));
    if (!bands.length) return;

    var canHover = window.matchMedia('(hover: hover)').matches;

    function closeAll() {
      bands.forEach(function (b) {
        b.removeAttribute('data-open');
        b.setAttribute('aria-expanded', 'false');
      });
    }

    bands.forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function (e) {
        if (canHover) return; // desktop already spotlights on hover
        e.preventDefault();
        e.stopPropagation();
        var wasOpen = b.hasAttribute('data-open');
        closeAll();
        if (!wasOpen) {
          b.setAttribute('data-open', '');
          b.setAttribute('aria-expanded', 'true');
        }
      });
    });

    if (!canHover) {
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.ws-hs')) return;
        closeAll();
      });
    }
  }

  function init() { reveals(); crew(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
